<template>
  <div id="container" class="cs_st grid-container">
    <!-- Location START -->

    <!-- TODO: Should use Subbar component and hide the moveList option buttons -->
    <BaseLocation current-group-name="serviceCenter" />
    <!-- Location END -->

    <!-- 자주하는 질문 -->
    <div class="section fill">
      <div class="inner">
        <!--FAQ 검색영역-->
        <h2>{{ $t('common.footer.7188') }}</h2>
        <!-- <p class="sub">{{ $t('views.help.faq.8433') }}</p> -->
        <div class="search_area">
          <form @submit.prevent="search">
            <legend class="blind">검색</legend>
            <div class="search_box">
              <label for="search-book" class="lab hidden">{{
                $t('views.help.faq.2181')
              }}</label>
              <input
                id="search-book"
                v-model="searchTerm"
                type="text"
                name="search"
                :placeholder="$t('views.help.faq.696')"
                value=""
              />
              <button type="button" class="btn_search" @click="search">
                <span class="svg_search"></span><span class="blind">검색</span>
              </button>
            </div>
          </form>
        </div>
        <!--FAQ 검색영역-->

        <!-- Tab START -->
        <div class="link_tab">
          <ul>
            <li
              v-for="(cat, idx) in categoryMapping"
              :key="idx"
              :class="{ active: category === cat.categryCd }"
            >
              <button
                class="link_tab_menu"
                data-tab-content="all"
                :tabindex="isNiaMode ? 0 : false"
                @click="setActiveFilter(cat.categryCd)"
              >
                {{ $t(`views.help.faq.${cat.categryNm}`) }}
              </button>
            </li>
          </ul>
        </div>
        <!-- Tab END -->

        <!-- Filtered Faq Tab Content -->
        <div class="tab_detail">
          <!-- tab content 1 - 전체 -->
          <div class="tab_page" data-tab-content="all">
            <ul v-if="getFaq" class="faq_list" data-list-itemumns="list">
              <li
                v-for="(faq, idx) in getFaq"
                :key="idx"
                :class="{ active: idx === selected }"
                :tabindex="isNiaMode ? 0 : false"
                @click="expandFaq(idx)"
                @keypress="expandFaq(idx)"
              >
                <div class="tit">
                  <p class="txt que" tabindex="0">
                    {{ faq.question }}
                  </p>

                  <span class="cat member">{{
                    $t(
                      'views.help.faq.' +
                        categoryMapping.find(
                          (e) => e.categryCd === faq.questionCd
                        ).categryNm
                    )
                  }}</span>
                </div>
                <div class="cont">
                  <div class="txt ans">
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <p v-html="faq.answer"></p>
                  </div>
                </div>
              </li>
            </ul>
            <EmptyData v-else data-tp="질문" />
          </div>

          <Pagination
            v-if="getFaq"
            :current-page="currentPage"
            :total-count="getFaqTotalCount"
            :item-per-page="faqPerPage"
            @paginate="paginate"
          />
        </div>
      </div>
    </div>
    <!-- <transition name="slide-right"> -->
    <Sidebar />
    <!-- </transition> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { FAQ_GET_LIST, UI_SHOW_SIDEBAR } from '@/store/types'
import { isNiaMode } from '@/store/constants'
import BaseLocation from '../../components/base/BaseLocation.vue'
import EmptyData from '../../components/common/EmptyData.vue'

export default {
  name: 'Faq',
  components: { BaseLocation, EmptyData },

  data() {
    return {
      searchTerm: '',
      showListMenu: false,
      selected: null,
      category: '0',
      categoryMapping: [
        { categryNm: 'faqBar1', categryCd: '0' },
        { categryNm: 'faqBar2', categryCd: '1' },
        { categryNm: 'faqBar3', categryCd: '2' },
        { categryNm: 'faqBar5', categryCd: '4' },
        { categryNm: 'faqBar6', categryCd: '5' },
        { categryNm: 'faqBar9', categryCd: '8' }
      ],
      currentPage: 1,
      faqPerPage: 10,
      isNiaMode
    }
  },
  computed: {
    ...mapGetters([
      'getFaq',
      'isFaqLoading',
      'getFaqTotalCount',
      'isSidebarOpen'
    ])
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      try {
        // console.log(to.params.eventCd)
        await vm.$store.dispatch(FAQ_GET_LIST, {
          search: 'ALL',
          page: 1,
          perPageCount: vm.faqPerPage
        })
        return true
      } catch (err) {
        // vm.$router.replace({
        //   query: ''
        // })

        next()
        return true
      }
    })
  },
  mounted() {
    // this.searchTerm = this.$route.params.searchTerm || ''
    // if (this.searchTerm) {
    //   this.search()
    // } else {
    //   if (!this.getFaq) {
    //     this.$store.dispatch(FAQ_GET_LIST, {
    //       page: this.currentPage,
    //       perPageCount: this.faqPerPage
    //     })
    //   }
    // }
  },
  methods: {
    openSidebar() {
      this.$store.commit(UI_SHOW_SIDEBAR)
    },
    aa(idx) {
      this.setActiveFilter(idx)
    },
    setActiveFilter(value) {
      this.category = value
      this.selected = null
      this.currentPage = 1

      this.loadFaq()
    },
    loadFaq() {
      this.$store.dispatch(FAQ_GET_LIST, {
        page: this.currentPage,
        perPageCount: this.faqPerPage,
        category: this.category,
        searchTerm: this.searchTerm
      })
    },
    expandFaq(idx) {
      if (this.selected === idx) {
        this.selected = null
      } else {
        this.selected = idx
      }
    },

    paginate(page) {
      this.currentPage = page
      this.loadFaq()
    },
    search() {
      if (!this.searchTerm) {
        return
      }

      this.currentPage = 1
      this.category = 0

      this.loadFaq()
    },
    closeListMenu() {
      this.showListMenu = false
    },
    toggleListMenu() {
      this.showListMenu = !this.showListMenu
    }
  }
}
</script>
<style src="@/assets/css/page_customer.css" scoped></style>
<style lang="scss" scoped>
@media (max-width: 1440px) {
  .cs_st .link_tab li {
    width: auto;
  }
}
@media (max-width: 1024px) {
  .cs_st .link_tab li {
    width: calc(100% / 9 - 1px);
  }
}
@media (max-width: 767px) {
  .cs_st .link_tab li {
    width: calc(100% / 3 - 1px);
  }
}
</style>
